import { render, staticRenderFns } from "./PreferencesSelect.vue?vue&type=template&id=a57267be&"
import script from "./PreferencesSelect.vue?vue&type=script&lang=js&"
export * from "./PreferencesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports